<template>
  <div
    class="distances"
    :class="{'expanded':expanded}"
  >
    <div
      class="distances__title"
      @click="expanded=!expanded"
    >
      <div class="distances__title-text">Расстояния от центра до грани по осям</div>
      <div class="distances__title-checked">Отмечено: {{ countCheckboxes }} шт.</div>
    </div>

    <ClientModal
      v-if="expanded"
      :isAdminPage="true"
      @close-modal="onClose"
    >
      <template #header>
        <div class="distances__header">Расстояния от центра до грани по осям</div>
      </template>

      <div
        class="distances__error"
        v-if="!formFacesProp.length"
      >
        Не выбрано ни одной грани для указания расстояний отдаления от центра по осям!
      </div>

      <div
        class="distances__error"
        v-if="distancesError"
      >
        Если поле активно, то его значение не должно быть нулевым!
      </div>

      <div class="distance__items">
        <div
          class="distance__item"
          v-for="(distance, i) in distances.filter(d=>d.show)"
        >
          <div class="distance__item-title">
            <span>{{ i+1 }}.</span> {{ distance.face.name }}
          </div>
          <div class="distance__values">
            <div
              class="distance__value"
              :class="{'distance__value-error':distance.x_error}"
            >

              <input
                type="checkbox"
                v-model="distance.x_active"
                :id="`${prefixLabel}-face-${distance.face.id}-x`"
              >
              <label :for="`${prefixLabel}-face-${distance.face.id}-x`"><b>Х</b> (&ang;{{distance.face.rotate_x}}&deg;):</label>
              <input
                type="number"
                placeholder="0"
                v-model="distance.x_value"
                :disabled="!distance.x_active"
              >
              <span>см</span>

            </div>
            <div
              class="distance__value"
              :class="{'distance__value-error':distance.y_error}"
            >

              <input
                type="checkbox"
                v-model="distance.y_active"
                :id="`${prefixLabel}-face-${distance.face.id}-y`"
              >
              <label :for="`${prefixLabel}-face-${distance.face.id}-y`"><b>Y</b> (&ang;{{distance.face.rotate_y}}&deg;):</label>
              <input
                :disabled="!distance.y_active"
                type="number"
                placeholder="0"
                v-model="distance.y_value"
              >
              <span>см</span>

            </div>
            <div
              class="distance__value"
              :class="{'distance__value-error':distance.z_error}"
            >

              <input
                type="checkbox"
                v-model="distance.z_active"
                :id="`${prefixLabel}-face-${distance.face.id}-z`"
              >
              <label :for="`${prefixLabel}-face-${distance.face.id}-z`"><b>Z</b> (&ang;{{distance.face.rotate_z}}&deg;):</label>
              <input
                :disabled="!distance.z_active"
                type="number"
                placeholder="0"
                v-model="distance.z_value"
              >
              <span>см</span>
            </div>
          </div>
        </div>
      </div>
    </ClientModal>

  </div>
</template>
<script>
export default {
  name: "FaceDistances",
  props: {
    prefixLabel: {
      type: String,
      default: "",
    },
    groupFacesProp: {
      type: Array,
      default: () => [],
    },
    formFacesProp: {
      type: Array,
      default: () => [],
    },
    sizeFaceDistancesProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
      distances: [],
      distancesError: false,
    };
  },
  mounted() {
    this.initDistances();
    this.$watch(
      "formFacesProp",
      (formFaces) => {
        this.changeDistances(formFaces);
      },
      { deep: true }
    );
  },
  methods: {
    initDistances() {
      this.groupFacesProp.forEach((gf) => {
        const sizeDistance = this.sizeFaceDistancesProp.find(
          (sfdp) => sfdp.face_id == gf.id
        );
        const distance = {
          face: {
            id: gf.id,
            name: gf.name,
            rotate_x: gf.rotate_x,
            rotate_y: gf.rotate_y,
            rotate_z: gf.rotate_z,
          },
          x_active: sizeDistance ? !!+sizeDistance.x_active : false,
          x_value: sizeDistance ? +sizeDistance.x_value : 0,
          y_active: sizeDistance ? !!+sizeDistance.y_active : false,
          y_value: sizeDistance ? +sizeDistance.y_value : 0,
          z_active: sizeDistance ? !!+sizeDistance.z_active : false,
          z_value: sizeDistance ? +sizeDistance.z_value : 0,
          show: this.formFacesProp.includes(gf.id),
        };
        this.distances.push(distance);
      });
    },
    changeDistances(formFaces) {
      this.distances = this.distances.map((d) => ({
        ...d,
        show: formFaces.includes(d.face.id),
      }));
    },
    resetErrors() {
      this.distancesError = false;
      for (let index = 0; index < this.distances.length; index++) {
        if (this.distances[index].x_error)
          this.distances[index].x_error = false;
        if (this.distances[index].y_error)
          this.distances[index].y_error = false;
        if (this.distances[index].z_error)
          this.distances[index].z_error = false;
      }
    },
    onClose() {
      if (!this.formFacesProp.length) {
        this.distancesError = false;
        this.expanded = false;
        return true;
      }

      this.resetErrors();

      for (let index = 0; index < this.distances.length; index++) {
        if (
          this.distances[index].x_active &&
          +this.distances[index].x_value === 0
        ) {
          this.distances[index].x_error = true;
          this.distancesError = true;
        }
        if (
          this.distances[index].y_active &&
          +this.distances[index].y_value === 0
        ) {
          this.distances[index].y_error = true;
          this.distancesError = true;
        }
        if (
          this.distances[index].z_active &&
          +this.distances[index].z_value === 0
        ) {
          this.distances[index].z_error = true;
          this.distancesError = true;
        }
      }

      if (!this.distancesError) {
        this.expanded = false;
      }
    },
  },
  computed: {
    countCheckboxes() {
      let countCheckboxes = 0;
      this.distances.forEach((d) => {
        if (d.x_active) countCheckboxes++;
        if (d.y_active) countCheckboxes++;
        if (d.z_active) countCheckboxes++;
      });
      return countCheckboxes;
    },
  },

  watch: {
    distances: {
      handler(distances) {
        this.$emit("changeDistances", distances);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.distances {
  background-color: #c5ecd2;
  border-radius: 4px;
  margin-bottom: 15px;
}
.distances__title {
  padding: 10px;
  line-height: 1;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
}

.distances__title-text {
  font-size: 14px;
  color: #3c714e;
  font-weight: bold;
}

.distances__title-checked {
  color: #3c715b;
  font-size: 14px;
}
.distances__header {
  font-size: 17px;
  font-weight: bold;
  color: #1f2937;
}
.distance__items {
  height: 0;
  opacity: 0;
  transition: all 0.2s;
  /* padding: 0 10px 10px; */
  display: flex;
  flex-direction: column;
  row-gap: 11px;
}

.distances.expanded .distance__items {
  height: auto;
  opacity: 1;
  padding: 0 10px 10px;
}
.distance__item-title {
  font-size: 12px;
  margin-bottom: 3px;
}
.distance__values {
  display: flex;
  justify-content: space-between;
  gap: 7px;
  flex-wrap: wrap;
}
.distance__value {
  display: flex;
  gap: 5px;
  font-size: 12px;
  align-items: center;
}
.distance__value input[type="number"] {
  width: 60px;
  height: 30px;
  text-align: center;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 3px;
  border: 1px solid #93baa0;
  font-size: 14px;
}
.distance__value-error input[type="number"] {
  border-color: #ff0000;
}

.distance__value input[type="checkbox"] {
  display: none;
}
.distance__value label {
  margin: 0;
  display: flex;
  column-gap: 7px;
  cursor: pointer;
}
.distance__value label::before {
  content: "";
  display: grid;
  place-content: center;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #cfe2e8;
  font-size: 16px;
  color: #ef4444;
  background-repeat: no-repeat;
  background-position: center center;
}
.distance__value input[type="checkbox"]:checked + label::before {
  background-image: url("/images/design/icon-check-solid.svg");
}
.distances__error {
  font-size: 17px;
  color: #ff0000;
  margin-bottom: 10px;
}
</style>
